import React from 'react';
import PropTypes from 'prop-types';
import PostSearchInput from './PostSearchInput.jsx';
import AuthorSearchInput from './AuthorSearchInput.jsx';

function SearchInput(props) {
  const { text, filter, onChange } = props;
  return filter === 'author' ? (
    <AuthorSearchInput value={text} onChange={(event) => onChange(event.target.value)} />
  ) : (
    <PostSearchInput value={text} onChange={(event) => onChange(event.target.value)} />
  );
}

SearchInput.propTypes = {
  text: PropTypes.string,
  onChange: PropTypes.func,
  filter: PropTypes.string,
};

export default SearchInput;
